import React, { useState } from "react";
import DatePicker from "react-datepicker";

const Example = () => {
    const [startDate, setStartDate] = useState(new Date());
    return (
        <DatePicker
            dateFormat="yyyy"
            selected={startDate} onChange={(date) => setStartDate(date)} />
    );
};

export default Example;
